// BUG-030 — the single character cap for a testimonial quote, shared by every place that
// writes or reads one. Before this file existed there were TWO independent mechanisms: a
// write-time cap (TestimonialsAdmin.jsx, mirrored on backend/server.py) and a read-time
// CSS `line-clamp` on six of the seven render surfaces plus a THIRD, different JS character
// slice on the seventh (Testimonials.jsx's desktop popup) — three different numbers for one
// quote. There is now exactly one number and one truncation mechanism, imported everywhere.
//
// Mirrors backend/server.py TESTIMONIAL_QUOTE_MAX_LENGTH — frontend and backend cannot
// import each other, so that copy is a literal kept in sync by convention (as is
// admin/TestimonialsAdmin.jsx's own QUOTE_MAX_LENGTH, which a regression test reads by
// regex and therefore must stay a literal number, not an import of this constant). Move
// all three together.
export const TESTIMONIAL_QUOTE_MAX_LENGTH = 180;

// The one truncation mechanism, used identically by all seven render surfaces. The cap IS
// the render slice — there is no separate, smaller budget carved out for the guillemets
// ("« " + content + " »") the renderer adds, because those are decoration the renderer
// contributes, not part of the practitioner's content. A quote written at or under the
// current cap is therefore always shown in full; this is a bounded safety net only for
// LEGACY rows written before the cap was lowered (up to the old 400-character ceiling).
export const formatQuote = (quote) => {
  const q = quote || "";
  const body =
    q.length > TESTIMONIAL_QUOTE_MAX_LENGTH
      ? `${q.slice(0, TESTIMONIAL_QUOTE_MAX_LENGTH).trim()}…`
      : q;
  return `« ${body} »`;
};
